(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('md-cart')) {
    class MdCart extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
        this.addEventListener('submit', this.onSubmit);
        this.addEventListener('input', this.onInput);
        this.loadRecommendations();
        this.syncSamples();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('submit', this.onSubmit);
        this.removeEventListener('input', this.onInput);
        clearTimeout(this.noteTimer);
      }

      get busy() {
        return this.hasAttribute('data-busy');
      }

      set busy(value) {
        this.toggleAttribute('data-busy', value);
      }

      /** Ridisegna la sezione con il carrello aggiornato, senza ricaricare. */
      async refresh() {
        const url = `${this.dataset.cartUrl}?section_id=${this.dataset.sectionId}`;
        const response = await fetch(url);
        const text = await response.text();
        const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('md-cart');
        if (!fresh) return;

        // Il campo del messaggio regalo non si tocca: chi sta scrivendo non
        // deve vedersi cancellare la frase a metà.
        const note = this.querySelector('[data-md-cart-note]');
        const noteValue = note?.value;
        const focused = document.activeElement?.closest('md-cart') === this ? document.activeElement : null;
        const focusedName = focused?.getAttribute('data-md-focus-key');

        this.innerHTML = fresh.innerHTML;
        this.dataset.itemCount = fresh.dataset.itemCount;

        const freshNote = this.querySelector('[data-md-cart-note]');
        if (freshNote && noteValue != null) freshNote.value = noteValue;
        if (focusedName) this.querySelector(`[data-md-focus-key="${focusedName}"]`)?.focus();

        this.loadRecommendations();
        this.syncSamples();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }

      async post(url, body) {
        if (this.busy) return;
        this.busy = true;
        try {
          await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          await this.refresh();
        } catch (error) {
          console.error(error);
        } finally {
          this.busy = false;
        }
      }

      onChange = (event) => {
        const qty = event.target.closest('[data-md-qty]');
        if (qty) {
          this.post(this.dataset.changeUrl, {
            line: Number(qty.dataset.mdQty),
            quantity: Number(qty.value),
          });
          return;
        }

        const toggle = event.target.closest('[data-md-cart-add-toggle]');
        if (toggle) {
          const id = Number(toggle.dataset.mdCartAddToggle);
          const line = Number(toggle.dataset.mdLine || 0);
          if (toggle.checked) this.post(this.dataset.addUrl, { items: [{ id, quantity: 1 }] });
          else if (line) this.post(this.dataset.changeUrl, { line, quantity: 0 });
          return;
        }

        const gift = event.target.closest('[data-md-cart-gift-toggle]');
        if (gift) {
          const wrap = this.querySelector('[data-md-cart-note-wrap]');
          wrap?.toggleAttribute('hidden', !gift.checked);
          if (gift.checked) this.querySelector('[data-md-cart-note]')?.focus();
          else this.saveNote('');
        }
      };

      onClick = (event) => {
        const remove = event.target.closest('[data-md-remove]');
        if (remove) {
          event.preventDefault();
          this.post(this.dataset.changeUrl, { line: Number(remove.dataset.mdRemove), quantity: 0 });
          return;
        }

        const step = event.target.closest('[data-md-sample-step]');
        if (step) {
          event.preventDefault();
          this.stepSample(step);
          return;
        }

        const add = event.target.closest('[data-md-add]');
        if (add) {
          event.preventDefault();
          this.post(this.dataset.addUrl, { items: [{ id: Number(add.dataset.mdAdd), quantity: 1 }] });
        }
      };

      get sampleStatus() {
        return this.querySelector('[data-md-samples-status]');
      }

      /** Quante miniature ci sono già nel carrello, in tutto. */
      get sampleTotal() {
        return [...this.querySelectorAll('[data-md-sample]')].reduce(
          (total, item) => total + Number(item.dataset.qty || 0),
          0
        );
      }

      /** Aggiunge o toglie una miniatura, senza superare il massimo. */
      stepSample(button) {
        const item = button.closest('[data-md-sample]');
        if (!item) return;

        const direction = Number(button.dataset.mdSampleStep);
        const quantity = Number(item.dataset.qty || 0);
        const max = Number(this.sampleStatus?.dataset.max || 0);

        if (direction > 0) {
          if (max && this.sampleTotal >= max) return;
          const line = Number(item.dataset.line || 0);
          if (line > 0) this.post(this.dataset.changeUrl, { line, quantity: quantity + 1 });
          else this.post(this.dataset.addUrl, { items: [{ id: Number(item.dataset.variantId), quantity: 1 }] });
          return;
        }

        if (quantity <= 0) return;
        this.post(this.dataset.changeUrl, {
          line: Number(item.dataset.line),
          quantity: quantity - 1,
        });
      }

      /** Aggiorna il messaggio e spegne il più quando il tetto è raggiunto. */
      syncSamples() {
        const status = this.sampleStatus;
        if (!status) return;

        const max = Number(status.dataset.max || 0);
        const chosen = this.sampleTotal;
        const left = Math.max(max - chosen, 0);

        let template = status.dataset.messageEmpty;
        if (chosen > 0) template = left > 0 ? status.dataset.messageLeft : status.dataset.messageFull;

        status.textContent = (template || '')
          .replace('[max]', String(max))
          .replace('[chosen]', String(chosen))
          .replace('[left]', String(left));

        const full = max > 0 && chosen >= max;
        this.querySelectorAll('[data-md-sample-step="1"]').forEach((button) => {
          button.disabled = full;
        });
      }

      onInput = (event) => {
        const note = event.target.closest('[data-md-cart-note]');
        if (!note) return;

        const counter = this.querySelector('[data-md-cart-note-count]');
        if (counter) counter.textContent = String(note.value.length);

        // Si salva a mano ferma, non a ogni tasto.
        clearTimeout(this.noteTimer);
        this.noteTimer = setTimeout(() => this.saveNote(note.value), 700);
      };

      /** Il messaggio regalo viaggia come attributo dell'ordine. */
      async saveNote(value) {
        const key = this.querySelector('[data-md-cart-note]')?.dataset.attributeKey;
        if (!key) return;
        try {
          await fetch(this.dataset.updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { [key]: value } }),
          });
        } catch (error) {
          console.error(error);
        }
      }

      onSubmit = (event) => {
        const promo = event.target.closest('[data-md-promo]');
        if (!promo) return;
        event.preventDefault();

        const field = promo.querySelector('input');
        const code = field?.value.trim();
        if (!code) return;

        // Shopify non applica i codici dal carrello: si passa dall'indirizzo
        // /discount, che li aggancia alla sessione e riporta qui.
        const back = encodeURIComponent(this.dataset.cartUrl);
        window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${back}`;
      };

      /** Consigli di Shopify sul primo prodotto del carrello. */
      async loadRecommendations() {
        const rail = this.querySelector('[data-md-recommendations]');
        if (!rail || rail.dataset.loaded === 'true') return;

        const productId = rail.dataset.productId;
        if (!productId) return;

        const params = new URLSearchParams({
          product_id: productId,
          limit: rail.dataset.limit || '6',
          intent: rail.dataset.intent || 'complementary',
          section_id: 'md-cart-recommendations',
        });

        try {
          const response = await fetch(`${this.dataset.recommendUrl}?${params}`);
          const text = await response.text();
          const fresh = new DOMParser().parseFromString(text, 'text/html');
          const items = fresh.querySelector('[data-md-recommendations-list]');
          if (items && items.children.length > 0) {
            rail.innerHTML = items.innerHTML;
            rail.dataset.loaded = 'true';
            rail.closest('[data-md-recommendations-section]')?.removeAttribute('hidden');
          }
        } catch (error) {
          console.error(error);
        }
      }
    }

    customElements.define('md-cart', MdCart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('md-footer')) {
    class MdFooter extends HTMLElement {
      connectedCallback() {
        this.panels = [...this.querySelectorAll('[data-md-footer-accordion]')];
        if (this.panels.length === 0) return;

        // I <details> nascono aperti perché senza JavaScript il footer resti
        // leggibile: qui li richiudiamo finché lo schermo è stretto.
        this.desktop = window.matchMedia('(min-width: 64rem)');
        this.sync();
        this.desktop.addEventListener('change', this.sync);
        this.addEventListener('click', this.onSummaryClick);
      }

      disconnectedCallback() {
        this.desktop?.removeEventListener('change', this.sync);
        this.removeEventListener('click', this.onSummaryClick);
      }

      sync = () => {
        for (const panel of this.panels) {
          panel.open = this.desktop.matches;
          this.list(panel)?.style.removeProperty('height');
        }
      };

      list(panel) {
        return panel.querySelector('.md-footer-menu__list');
      }

      get reduced() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      // Il <details> apre e chiude di scatto: qui l'altezza dell'elenco viene
      // animata a mano, tenendo il pannello aperto finché la chiusura non è
      // finita, altrimenti il contenuto sparirebbe al primo fotogramma.
      onSummaryClick = (event) => {
        const summary = event.target.closest('summary');
        const panel = summary?.closest('[data-md-footer-accordion]');
        if (!panel || !this.panels.includes(panel)) return;
        if (this.desktop.matches || this.reduced) return;

        const list = this.list(panel);
        if (!list) return;

        event.preventDefault();
        list.getAnimations().forEach((animation) => animation.cancel());

        const closing = panel.open;
        if (!closing) panel.open = true;

        const start = closing ? `${list.scrollHeight}px` : '0px';
        const end = closing ? '0px' : `${list.scrollHeight}px`;

        const animation = list.animate(
          { height: [start, end], opacity: closing ? [1, 0] : [0, 1] },
          { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );

        list.style.overflow = 'hidden';
        animation.finished
          .then(() => {
            if (closing) panel.open = false;
            list.style.removeProperty('overflow');
            list.style.removeProperty('height');
          })
          .catch(() => {});
      };
    }

    customElements.define('md-footer', MdFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-hero-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('md-hero-story')) {
    /** Finestra finale verticale 2:3. */
    const CLIP_RATIO = 1.5;

    class MdHeroStory extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.md-hero__trigger');
        this.column = this.querySelector('.md-hero__column');
        this.video = this.querySelector('video');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.reducedMotion.addEventListener('change', this.applyMotionPreference);

        this.resizeObserver = new ResizeObserver(this.measure);
        if (this.column) this.resizeObserver.observe(this.column);

        this.dataset.ready = '';
        this.applyMotionPreference();
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.reducedMotion?.removeEventListener('change', this.applyMotionPreference);
      }

      applyMotionPreference = () => {
        this.intersectionObserver?.disconnect();

        if (this.reducedMotion.matches) {
          this.toggleAttribute('data-active', true);
          this.video?.pause();
          return;
        }

        this.video?.play().catch(() => {});
        if (!this.trigger) return;
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.toggleAttribute('data-active', scrolledPast);
        });
        this.intersectionObserver.observe(this.trigger);
      };

      /**
       * La finestra è larga quanto la colonna centrale (7 tracce su 23) e alta
       * 1,5 volte tanto; il visual, largo 100vw, va spostato del left della
       * colonna per tornare centrato sul viewport.
       */
      measure = () => {
        if (!this.column) return;
        const rect = this.column.getBoundingClientRect();
        this.style.setProperty('--clip-x', `${rect.width / 2}px`);
        this.style.setProperty('--clip-y', `${(rect.width * CLIP_RATIO) / 2}px`);
        this.style.setProperty('--visual-x', `${-rect.left}px`);
      };
    }

    customElements.define('md-hero-story', MdHeroStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-hero-template-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('md-hero-product')) {
    class MdHeroProduct extends HTMLElement {
      connectedCallback() {
        this.currentIndex = 0;
        this.addEventListener('click', this.onClick);
        this.notifyDialog = this.querySelector('[data-md-notify]');
        this.notifyDialog?.addEventListener('cancel', this.onNotifyCancel);
        // Tornando dall'invio la finestra si riapre sul messaggio.
        if (this.notifyDialog?.querySelector('[data-md-notify-open]')) {
          this.notifyDialog.classList.toggle(
            'is-sent',
            Boolean(this.notifyDialog.querySelector('[data-md-notify-success]'))
          );
          this.openNotify('');
        }
        this.thumbList?.addEventListener('scroll', this.syncThumbNav, { passive: true });
        window.addEventListener('resize', this.syncThumbNav);
        this.syncThumbNav();
        this.querySelector('.md-hero-product__stage')?.addEventListener('scroll', this.onStageScroll, {
          passive: true,
        });
        this.hint = this.querySelector('[data-md-hero-savings]');
        const selected = this.querySelector('.md-hero-product__size.is-selected');
        if (selected) this.selectSize(selected, { updateUrl: false });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.notifyDialog?.removeEventListener('cancel', this.onNotifyCancel);
        this.querySelector('.md-hero-product__stage')?.removeEventListener('scroll', this.onStageScroll);
        this.thumbList?.removeEventListener('scroll', this.syncThumbNav);
        window.removeEventListener('resize', this.syncThumbNav);
      }

      get isSlider() {
        return window.matchMedia('(max-width: 63.99rem)').matches;
      }

      onClick = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const thumbNav = target.closest('[data-md-thumbs]');
        if (thumbNav) {
          this.scrollThumbs(Number(thumbNav.dataset.mdThumbs));
          return;
        }

        const arrow = target.closest('[data-md-arrow]');
        if (arrow) {
          this.scrollBySlides(Number(arrow.dataset.mdArrow));
          return;
        }

        const thumb = target.closest('[data-md-index]');
        if (thumb) {
          const index = Number(thumb.dataset.mdIndex);
          if (this.isSlider) this.scrollToSlide(index);
          else this.showMedia(index);
          return;
        }

        const notify = target.closest('[data-md-notify-variant]');
        if (notify) {
          this.openNotify(notify.dataset.mdNotifyVariant);
          return;
        }

        const dialog = this.querySelector('[data-md-notify]');
        if (target.closest('[data-md-notify-close]') || target === dialog) {
          this.closeNotify();
          return;
        }

        const size = target.closest('.md-hero-product__size');
        if (size && !size.disabled) this.selectSize(size, { updateUrl: true });
      };

      get thumbList() {
        return this.querySelector('[data-md-thumbs-list]');
      }

      /** Scorre la colonna delle miniature di una posizione per volta. */
      scrollThumbs(step) {
        const list = this.thumbList;
        const item = list?.querySelector('li');
        if (!list || !item) return;
        const gap = Number.parseFloat(getComputedStyle(list).rowGap) || 0;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        list.scrollBy({
          top: step * (item.getBoundingClientRect().height + gap),
          behavior: reduced ? 'auto' : 'smooth',
        });
      }

      /** Spegne le frecce quando la colonna è già in fondo o non scorre. */
      syncThumbNav = () => {
        const list = this.thumbList;
        if (!list) return;
        const scrollable = list.scrollHeight - list.clientHeight > 1;
        this.querySelectorAll('[data-md-thumbs]').forEach((button) => {
          button.hidden = !scrollable;
          const back = Number(button.dataset.mdThumbs) < 0;
          button.disabled = back
            ? list.scrollTop <= 1
            : list.scrollTop >= list.scrollHeight - list.clientHeight - 1;
        });
      };

      /** Porta in vista la miniatura corrente quando si cambia scatto. */
      revealThumb(index) {
        const list = this.thumbList;
        const thumb = list?.querySelector(`[data-md-index="${index}"]`);
        if (!list || !thumb) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        thumb.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
      }

      scrollToSlide(index) {
        const stage = this.querySelector('.md-hero-product__stage');
        const slides = this.querySelectorAll('[data-md-slide]');
        if (!stage || slides.length === 0) return;
        const next = (index + slides.length) % slides.length;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        stage.scrollTo({ left: next * stage.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
        this.markCurrent(next);
      }

      scrollBySlides(step) {
        this.scrollToSlide(this.currentIndex + step);
      }

      /** Segna miniature e pallini, senza toccare le slide. */
      markCurrent(index) {
        this.currentIndex = index;
        this.revealThumb(index);
        this.querySelectorAll('[data-md-index]').forEach((control) => {
          const isCurrent = Number(control.dataset.mdIndex) === index;
          control.classList.toggle('is-active', isCurrent);
          if (isCurrent) control.setAttribute('aria-current', 'true');
          else control.removeAttribute('aria-current');
        });
      }

      onStageScroll = () => {
        if (!this.isSlider || this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const stage = this.querySelector('.md-hero-product__stage');
          if (!stage) return;
          const index = Math.round(stage.scrollLeft / (stage.clientWidth || 1));
          if (index !== this.currentIndex) this.markCurrent(index);
        });
      };

      showMedia(index) {
        this.currentIndex = index;
        this.revealThumb(index);
        this.querySelectorAll('[data-md-index]').forEach((thumb) => {
          const isCurrent = Number(thumb.dataset.mdIndex) === index;
          thumb.classList.toggle('is-active', isCurrent);
          if (isCurrent) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });

        this.querySelectorAll('[data-md-slide]').forEach((slide) => {
          const isCurrent = Number(slide.dataset.mdSlide) === index;
          slide.classList.toggle('is-active', isCurrent);
          if (!isCurrent) slide.querySelector('video')?.pause();
        });
      }

      /** Apre la finestra dell'avviso e ci scrive dentro il formato chiesto. */
      openNotify(variantTitle) {
        const dialog = this.querySelector('[data-md-notify]');
        if (!dialog || dialog.open) return;

        const body = dialog.querySelector('[data-md-notify-body]');
        if (body && variantTitle) body.value = `${body.dataset.mdNotifyBody} — ${variantTitle}`;

        const label = dialog.querySelector('[data-md-notify-label]');
        if (label) label.textContent = variantTitle || '';

        dialog.classList.remove('is-closing');
        dialog.showModal();
        dialog.querySelector('input[type="email"]')?.focus();
      }

      onNotifyCancel = (event) => {
        event.preventDefault();
        this.closeNotify();
      };

      /** Chiude aspettando l'animazione, altrimenti sparirebbe di scatto. */
      closeNotify = () => {
        const dialog = this.querySelector('[data-md-notify]');
        if (!dialog?.open) return;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) {
          dialog.close();
          return;
        }

        dialog.classList.add('is-closing');
        const done = () => {
          dialog.classList.remove('is-closing');
          dialog.close();
        };
        Promise.all(dialog.getAnimations().map((animation) => animation.finished))
          .then(done)
          .catch(done);
      };

      selectSize(button, { updateUrl }) {
        this.querySelectorAll('.md-hero-product__size:not(:disabled)').forEach((size) => {
          const isCurrent = size === button;
          size.classList.toggle('is-selected', isCurrent);
          size.setAttribute('aria-pressed', String(isCurrent));
        });

        const productId = this.dataset.productId;
        const { variantId, price } = button.dataset;

        if (variantId) {
          document
            .querySelectorAll(`[data-md-variant-input][data-product-id="${productId}"]`)
            .forEach((input) => (input.value = variantId));

          if (updateUrl) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', url);
          }
        }

        if (price) {
          document
            .querySelectorAll(`[data-md-price][data-product-id="${productId}"]`)
            .forEach((element) => (element.textContent = price));
        }

        if (this.hint) this.hint.textContent = button.dataset.savings || '';
      }
    }

    customElements.define('md-hero-product', MdHeroProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-product-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('md-product-gallery')) {
    class MdProductGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.md-product-gallery__track');
        this.slides = Array.from(this.querySelectorAll('.md-product-gallery__slide'));
        this.indicators = Array.from(this.querySelectorAll('[data-md-index]'));
        this.lightbox = this.querySelector('.md-product-gallery__lightbox');
        this.zoomFrame = this.querySelector('.md-product-gallery__zoom-frame');
        this.index = 0;

        this.addEventListener('click', this.onClick);
        this.track?.addEventListener('scroll', this.onScroll, { passive: true });
        this.track?.addEventListener('keydown', this.onKeydown);
        this.lightbox?.addEventListener('click', this.onLightboxClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('keydown', this.onKeydown);
        this.lightbox?.removeEventListener('click', this.onLightboxClick);
      }

      get behavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      goTo(index) {
        if (!this.track || this.slides.length === 0) return;
        const next = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: next * this.track.clientWidth, behavior: this.behavior });
        this.setIndex(next);
      }

      setIndex(index) {
        this.index = index;
        for (const indicator of this.indicators) {
          const current = Number(indicator.dataset.mdIndex) === index;
          if (current) indicator.setAttribute('aria-current', 'true');
          else indicator.removeAttribute('aria-current');
        }
      }

      onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const width = this.track.clientWidth || 1;
          const index = Math.round(this.track.scrollLeft / width);
          if (index !== this.index) this.setIndex(index);
        });
      };

      onKeydown = (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.index + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.index - 1);
        }
      };

      onClick = (event) => {
        const indicator = event.target.closest('[data-md-index]');
        if (indicator) {
          this.goTo(Number(indicator.dataset.mdIndex));
          return;
        }

        const action = event.target.closest('[data-md-action]')?.dataset.mdAction;
        if (action === 'expand') this.openLightbox();
        if (action === 'close') this.lightbox?.close();
      };

      openLightbox() {
        const slide = this.slides[this.index];
        if (!this.lightbox || !this.zoomFrame || !slide?.dataset.mdZoom) return;
        const image = document.createElement('img');
        image.className = 'md-product-gallery__zoom';
        image.src = slide.dataset.mdZoom;
        image.alt = slide.dataset.mdAlt || '';
        this.zoomFrame.replaceChildren(image);
        this.lightbox.showModal();
      }

      onLightboxClick = (event) => {
        if (event.target === this.lightbox) this.lightbox.close();
      };
    }

    customElements.define('md-product-gallery', MdProductGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('md-quiz')) {
    class MdQuiz extends HTMLElement {
      connectedCallback() {
        this.stepEls = [...this.querySelectorAll('[data-md-step]')];
        this.questions = [...this.querySelectorAll('[data-md-question]')];
        this.results = [...this.querySelectorAll('[data-md-result]')];
        this.progress = this.querySelector('[data-md-progress]');
        this.progressText = this.querySelector('[data-md-progress-text]');
        this.form = this.querySelector('[data-md-contact-form]');
        this.error = this.querySelector('[data-md-error]');
        this.labelTemplate = this.dataset.progressLabel || '';
        this.wantsContact = this.dataset.contact === 'true' && !!this.form;

        this.buildProgress();
        this.reset();

        this.addEventListener('click', this.onClick);
        this.form?.addEventListener('submit', this.onSubmit);
      }

      buildProgress() {
        if (!this.progress) return;
        this.progress.replaceChildren(
          ...this.questions.map(() => document.createElement('span'))
        );
      }

      reset = () => {
        this.scores = { A: 0, B: 0, C: 0 };
        this.index = 0;
        this.error?.setAttribute('hidden', '');
        this.form?.reset();
        this.hideBlocks();
        this.show('intro');
      };

      show(step) {
        // Una fase può avere più elementi (il risultato ha testa e piede).
        for (const el of this.stepEls) el.toggleAttribute('hidden', el.dataset.mdStep !== step);
      }

      hideBlocks() {
        for (const el of [...this.questions, ...this.results]) el.setAttribute('hidden', '');
      }

      showQuestion(index) {
        this.index = index;
        this.questions.forEach((q, i) => q.toggleAttribute('hidden', i !== index));
        [...(this.progress?.children || [])].forEach((seg, i) =>
          seg.toggleAttribute('data-done', i <= index)
        );
        if (this.progressText) {
          this.progressText.textContent = this.labelTemplate
            .replace('[n]', String(index + 1))
            .replace('[tot]', String(this.questions.length));
        }
        this.show('questions');
        this.questions[index]?.querySelector('.md-quiz__question-text')?.focus?.();
      }

      answer(key) {
        if (key in this.scores) this.scores[key] += 1;
        if (this.index + 1 < this.questions.length) {
          this.showQuestion(this.index + 1);
        } else if (this.wantsContact) {
          this.prepareContact();
          this.hideBlocks();
          this.show('contact');
        } else {
          this.showResult();
        }
      }

      get winner() {
        // A parità vince la prima chiave in ordine A, B, C, come nell'originale.
        return ['A', 'B', 'C'].reduce((top, k) => (this.scores[k] > this.scores[top] ? k : top), 'A');
      }

      get winningResult() {
        return this.results.find((r) => r.dataset.mdResult === this.winner) || this.results[0];
      }

      prepareContact() {
        const body = this.form?.querySelector('[data-md-contact-body]');
        const name = this.winningResult?.querySelector('[data-md-result-name]')?.dataset.mdResultName;
        if (!body) return;
        // Si riparte sempre dal testo di partenza: rifacendo il quiz il nome
        // della fragranza non si accoda a quello di prima.
        body.value = name ? `${body.dataset.mdContactBody} — ${name}` : body.dataset.mdContactBody;
      }

      showResult() {
        const winning = this.winningResult;
        this.questions.forEach((q) => q.setAttribute('hidden', ''));
        this.results.forEach((r) => r.toggleAttribute('hidden', r !== winning));
        this.show('result');
        winning?.querySelector('.md-quiz__result-name')?.scrollIntoView?.({
          block: 'nearest',
          behavior: 'smooth',
        });
      }

      onClick = (event) => {
        const option = event.target.closest('[data-md-key]');
        if (option && this.contains(option)) return this.answer(option.dataset.mdKey);
        if (event.target.closest('[data-md-start]')) return this.showQuestion(0);
        if (event.target.closest('[data-md-skip]')) return this.showResult();
        if (event.target.closest('[data-md-restart]')) return this.reset();
      };

      // Il modulo parte in background: il risultato è già stato guadagnato e
      // non deve aspettare la risposta del negozio, né perdersi se fallisce.
      onSubmit = async (event) => {
        event.preventDefault();
        const button = this.form.querySelector('[type="submit"]');
        button?.setAttribute('disabled', '');
        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
          });
          if (!response.ok) throw new Error(String(response.status));
          this.error?.setAttribute('hidden', '');
        } catch {
          this.error?.removeAttribute('hidden');
        }
        button?.removeAttribute('disabled');
        this.showResult();
      };
    }

    customElements.define('md-quiz', MdQuiz);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-reassurance-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('md-reassurance-banner')) {
    class MdReassuranceBanner extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.md-reassure__list');
        this.dotsWrap = this.querySelector('[data-md-dots]');
        this.items = this.list ? Array.from(this.list.children) : [];
        if (!this.list || this.items.length < 2) return;

        this.current = 0;
        this.pauseUntil = 0;
        this.delay = Number(this.dataset.autoplay) || 4000;
        this.query = window.matchMedia('(max-width: 39.99rem)');

        this.buildDots();
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        this.list.addEventListener('pointerdown', this.onInteraction);
        this.list.addEventListener('touchstart', this.onInteraction, { passive: true });
        this.query.addEventListener('change', this.apply);
        document.addEventListener('visibilitychange', this.apply);
        this.apply();
      }

      disconnectedCallback() {
        this.stop();
        this.list?.removeEventListener('scroll', this.onScroll);
        this.list?.removeEventListener('pointerdown', this.onInteraction);
        this.list?.removeEventListener('touchstart', this.onInteraction);
        this.query?.removeEventListener('change', this.apply);
        document.removeEventListener('visibilitychange', this.apply);
      }

      buildDots() {
        if (!this.dotsWrap) return;
        this.dots = this.items.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', String(index + 1));
          dot.addEventListener('click', () => {
            this.goTo(index);
            this.pause(8000);
          });
          this.dotsWrap.appendChild(dot);
          return dot;
        });
        this.setActive(0);
      }

      setActive(index) {
        this.current = index;
        this.dots?.forEach((dot, i) => dot.setAttribute('aria-selected', String(i === index)));
      }

      goTo(index) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.list.scrollTo({ left: this.items[index].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
        this.setActive(index);
      }

      pause(ms) {
        this.pauseUntil = Date.now() + ms;
      }

      onInteraction = () => this.pause(8000);

      onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const index = Math.round(this.list.scrollLeft / (this.list.clientWidth || 1));
          const clamped = Math.max(0, Math.min(this.items.length - 1, index));
          if (clamped !== this.current) this.setActive(clamped);
        });
      };

      apply = () => {
        const sliderOn = this.dataset.slider === 'true' && this.query.matches && !document.hidden;
        if (sliderOn) this.start();
        else this.stop();
      };

      start() {
        this.stop();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = window.setInterval(() => {
          if (Date.now() < this.pauseUntil) return;
          this.goTo((this.current + 1) % this.items.length);
        }, this.delay);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('md-reassurance-banner', MdReassuranceBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('md-sticky-cta')) {
    class MdStickyCta extends HTMLElement {
      connectedCallback() {
        this.passed = false;
        this.onFooter = false;

        const { trigger } = this.dataset;
        let target = null;
        const followsAnchor = trigger === 'anchor' || trigger === 'anchor_visible';
        if (followsAnchor) target = document.querySelector('[data-md-cta-anchor]');
        if (trigger === 'hero' || (followsAnchor && !target)) {
          target = document.querySelector('.md-product-hero, .md-hero-product');
        }

        if (target) {
          this.triggerObserver = new IntersectionObserver(([entry]) => {
            const box = entry.boundingClientRect;
            // Un'ancora nascosta (display: none) non ha dimensioni: in quel caso
            // la pagina non mostra altre CTA e la barra resta sempre visibile.
            const hidden = box.width === 0 && box.height === 0;
            if (trigger === 'anchor_visible') {
              // Visibile ovunque tranne quando la CTA della scheda è a schermo.
              this.passed = hidden || !entry.isIntersecting;
            } else {
              this.passed = hidden || (!entry.isIntersecting && box.top < 0);
            }
            this.update();
          });
          this.triggerObserver.observe(target);
        } else {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        }

        if (this.dataset.hideFooter === 'true') {
          const footer = document.querySelector('.page-wrapper > footer') || document.querySelector('footer');
          if (footer) {
            this.footerObserver = new IntersectionObserver(([entry]) => {
              this.onFooter = entry.isIntersecting;
              this.update();
            });
            this.footerObserver.observe(footer);
          }
        }
      }

      disconnectedCallback() {
        this.triggerObserver?.disconnect();
        this.footerObserver?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
      }

      onScroll = () => {
        this.passed = window.scrollY > Number(this.dataset.offset || 0);
        this.update();
      };

      update() {
        const visible = this.passed && !this.onFooter;
        this.toggleAttribute('data-visible', visible);
        this.inert = !visible && !this.classList.contains('md-sticky-cta--editor');
      }
    }

    customElements.define('md-sticky-cta', MdStickyCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-video-fullscreen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('md-video-fullscreen')) {
    /** Quota di sezione visibile oltre la quale il video parte. */
    const PLAY_THRESHOLD = 0.5;

    class MdVideoFullscreen extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.playButton = this.querySelector('[data-md-action="play"]');
        this.audioButton = this.querySelector('[data-md-action="audio"]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.playButton?.addEventListener('click', this.togglePlayback);
        this.audioButton?.addEventListener('click', this.toggleAudio);

        if (this.video) {
          this.video.addEventListener('play', this.syncState);
          this.video.addEventListener('pause', this.syncState);
        }

        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) this.dataset.entered = '';
            if (!this.video || reducedMotion || this.dataset.autoplay === 'false') return;
            if (entry.intersectionRatio >= PLAY_THRESHOLD) this.video.play().catch(() => {});
            else this.video.pause();
          },
          { threshold: [0, PLAY_THRESHOLD, 1] }
        );
        this.observer.observe(this);
        this.syncState();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.playButton?.removeEventListener('click', this.togglePlayback);
        this.audioButton?.removeEventListener('click', this.toggleAudio);
        this.video?.removeEventListener('play', this.syncState);
        this.video?.removeEventListener('pause', this.syncState);
      }

      togglePlayback = () => {
        if (!this.video) return;
        if (this.video.paused) this.video.play().catch(() => {});
        else this.video.pause();
      };

      toggleAudio = () => {
        if (!this.video) return;
        this.video.muted = !this.video.muted;
        this.syncState();
      };

      syncState = () => {
        if (!this.video) return;
        const playing = !this.video.paused;
        const sound = !this.video.muted;

        this.toggleAttribute('data-playing', playing);
        this.toggleAttribute('data-sound', sound);
        this.playButton?.setAttribute('aria-label', playing ? this.dataset.labelPause : this.dataset.labelPlay);
        this.audioButton?.setAttribute('aria-label', sound ? this.dataset.labelMute : this.dataset.labelUnmute);
      };
    }

    customElements.define('md-video-fullscreen', MdVideoFullscreen);
  }

  } catch(e) { console.error(e); }
})();
})();
